<template>
  <h1 class="mt-6 font-sedgwick text-3xl text-center text-[#f8f7f2]">
    Projetos
  </h1>
  <div
    class="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5 justify-items-center"
  >
    <div
      class="rounded overflow-hidden shadow-lg bg-[#f8f7f2] border-2 hover:shadow-xl transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-100"
      v-for="post in posts"
      :key="post.id"
    >
      <a :href="post.link">
        <img :src="post.img" />
      </a>
      <div class="px-6 py-4">
        <div class="text-center text-xl mb-2">{{ post.titulo }}</div>
        <p class="text-gray-700 text-base text-justify">
          {{ post.descricao }}
        </p>
      </div>
      <!-- Stack -->
      <div class="px-6 py-4">
        <span
          class="inline-block bg-[#f8f7f2] rounded-full text-sm font-semibold text-[#050a30] mr-2 mb-2"
          >Stack: {{ post.stack }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      posts: [
        {
          id: 1,
          titulo: "Meraki",
          descricao:
            "Meraki conecta voluntários e ONGs para ajudar a comunidade.",
          img: require("@/assets/meraki.png"),
          link: "https://meraki-voluntariado.vercel.app/",
          stack: "MongoDB, Express, Vue.js, Node.js e Vercel.",
        },
        {
          id: 2,
          titulo: "IF Acolhe",
          descricao:
            "IF Acolhe controla os cães que circulam no IFC.",
          img: require("@/assets/ifacolhe.png"),
          link: "https://if-acolhe.vercel.app/",
          stack: "MongoDB, Express, Vue.js, Node.js e Vercel.",
        },
        {
          id: 3,
          titulo: "Livraria",
          descricao:
            "Livraria é um projeto que faz o gerenciamento de uma livraria.",
          img: require("@/assets/livraria.png"),
          link: "https://gustavokubiack.pythonanywhere.com/api",
          stack: "Django, Django Rest Framework, MySQL e PythonAnywhere.",
        },
        {
          id: 4,
          titulo: "Calculadora de IPv4",
          descricao:
            "Calculadora IPv4 calcula as informações da rede.",
          img: require("@/assets/ipv4.png"),
          link: "https://github.com/gustavokubiack/ipv4Calculator",
          stack: "Node.js.",
        },
        {
          id: 5,
          titulo: "nodeChat",
          descricao:
            "nodeChat é um projeto de um chat utilizando a API do ChatGPT.",
          img: require("@/assets/nodechat.png"),
          link: "https://github.com/gustavokubiack/nodeChat",
          stack: "Node.js.",
        },
      ],
    };
  },
};
</script>

<style>
</style>